import { useState, useEffect, useCallback, Fragment } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'

import { formatters } from 'reactUtils/formatters'

import { CouponNew } from 'lmcv/components/CouponNew'
import { Coupon } from 'lmcv/components/Coupon'
import { Icon } from 'lmcv/components/Icon'
import { useCouponShareModal, useCouponModal } from 'lmcv/hooks/modal'
import { Actions, Selectors } from 'lmcv/redux/modules/coupon'

import { formatter } from './helpers'

function CouponContainer (props) {
  const {
    id,
    thumbnail,
    title,
    type,
    shortDescription,
    remainingDays,
    giftedBy,
    isShared,
    isActive,
    price,
    loyaltyCouponFeatureFlip
  } = props

  const CouponFeatureFlip = localStorage.getItem('@loyalty:couponFeatureFlip', loyaltyCouponFeatureFlip)

  const dispatch = useDispatch()
  const data = useSelector(
    state => Selectors.getById(state.coupon[type].payload, props.id),
    shallowEqual
  )
  const user = useSelector(state => state.user.get, shallowEqual)

  const modalShare = useCouponShareModal({
    componentProps: {
      id: props.id,
      category: type,
      active: isActive
    }
  })

  const modalCommon = useCouponModal({
    componentProps: {
      id: props.id,
      category: type,
      active: isActive
    }
  })

  const getModal = data?.isShared && type === 'money' ? modalShare : modalCommon

  const [customProps, setCustomProps] = useState({
    footerText: {
      default: '',
      active: ''
    }
  })

  useEffect(() => {
    const remainingEl = (
      <Fragment>
        <Icon name="clock" />
        {formatter.days(remainingDays)}
      </Fragment>
    )

    if (type === 'percentage') {
      setCustomProps({
        footerText: {
          default: remainingEl,
          active: remainingEl
        }
      })
    }

    if (type === 'money') {
      setCustomProps({
        buttonText: {
          default: `${formatters.toDecimal(price)} pts`,
          active: 'Ativado'
        },
        footerText: {
          default: 'Troque por pontos',
          active: remainingEl
        },
        isDisabled: !isActive && user.payload.points.actual < price
      })
    }
  }, [type, remainingDays, price, user.payload.points.actual, isActive])

  const couponProps = {
    image: thumbnail,
    title,
    description: shortDescription,
    category: type,
    giftedBy,
    isActive,
    isShared,
    isLoading: data?.isLoading,
    onClickCoupon: useCallback(() => {
      getModal()
    }, [getModal]),
    onClickButton: useCallback(
      e => {
        e.stopPropagation()

        getModal()

        if (!isActive) {
          dispatch(Actions.active(id, type))
        }

        return null
      },
      [dispatch, type, id, isActive, getModal]
    ),
    ...customProps
  }

  return CouponFeatureFlip ? <CouponNew {...couponProps} /> : <Coupon {...couponProps} />
}

export default CouponContainer
